import type { OutreachContactPatch, OutreachRow } from '@discovr/types';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../../../components/ui/sheet';
import { CreatorProfileDrawer } from './CreatorProfileDrawer';

interface ProfileSheetProps {
  row: OutreachRow | null;
  campaignZone?: string;
  /** The campaign's Automatic follow-ups switch; OFF hides the automatic step's date in the drawer. */
  autoFollowups?: boolean;
  canWrite: boolean;
  onSave: (entryId: string, patch: OutreachContactPatch) => Promise<unknown>;
  onClose: () => void;
  onAgreeRate: (entryId: string) => void;
  onSendToBrand: (entryId: string) => void;
  onPauseFollowups: (entryId: string) => void;
  onResumeFollowups: (entryId: string) => void;
}

/** RowActions' "View profile": the same drawer ThreadHeader opens, as an
 *  overlay sheet here — there's no thread for it to sit beside. */
export function ProfileSheet({ row, campaignZone, autoFollowups, canWrite, onSave, onClose, onAgreeRate, onSendToBrand, onPauseFollowups, onResumeFollowups }: ProfileSheetProps) {
  const entryId = row?.entryId;
  return (
    <Sheet open={!!row} onOpenChange={(next) => { if (!next) onClose(); }}>
      {/* U11: the drawer carries the one close control; the sheet's own is off. */}
      <SheetContent side="right" showCloseButton={false} className="w-full sm:max-w-[572px]">
        <SheetHeader>
          {/* Not the drawer's visible "Creator profile": two elements must not share an accessible name. */}
          <SheetTitle className="sr-only">Creator profile panel</SheetTitle>
        </SheetHeader>
        <div className="flex min-h-0 flex-1 flex-col px-4 pb-4">
          <CreatorProfileDrawer
            open={!!row}
            row={row}
            campaignZone={campaignZone}
            autoFollowups={autoFollowups}
            canWrite={canWrite}
            onSave={async (patch) => {
              if (!entryId) return;
              await onSave(entryId, patch);
            }}
            onClose={onClose}
            onAgreeRate={() => entryId && onAgreeRate(entryId)}
            onSendToBrand={() => entryId && onSendToBrand(entryId)}
            onPauseFollowups={() => entryId && onPauseFollowups(entryId)}
            onResumeFollowups={() => entryId && onResumeFollowups(entryId)}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
